module.exports = __webpack_public_path__ + "img/39.0fac8101.jpg";